
const InitGsap = ({
    ScrollTrigger,
    gsap,
    manzaRef,
    homeRef,
    aboutRef,
    frontendRef,
    backendRef,
    aboutDescriptionRef,
    aboutProfilePhotoRef,
    contactRef,
}) => {
    ScrollTrigger.create({
        trigger: manzaRef.current,
        start: "top 27.5%",
        end: () => homeRef.current.clientHeight / 2,
        scrub: true,
        pin: manzaRef.current,
        toggleActions: "play none none none",
        // markers: true,
        onEnter: () => {
        },
        onLeaveBack: () => {
        }
    });

    gsap.timeline({
        scrollTrigger: {
            trigger: aboutRef.current,
            start: "top 90%",
            end: "top 0%",
            scrub: true,
            toggleActions: "play none none none",
            // markers: true,
            onEnter: () => { },
            onLeaveBack: () => { }
        },
    })
        .from(frontendRef.current, {
            x: -1500,
            duration: 1, ease: 'none',
        })

    gsap.timeline({
        scrollTrigger: {
            trigger: aboutRef.current,
            start: "top 90%",
            end: "top 0%",
            scrub: true,
            toggleActions: "play none none none",
            // markers: true,
            onEnter: () => { },
            onLeaveBack: () => { }
        },
    })
        .fromTo(backendRef.current, {
            x: 1800,
        }, {
            x: -600,
            duration: 1, ease: 'none',
        })

    ScrollTrigger.create({
        trigger: aboutDescriptionRef.current,
        start: "top 15%",
        end: "top -40%",
        scrub: true,
        pin: aboutProfilePhotoRef.current,
        toggleActions: "play none none none",
        // markers: true,
        onEnter: () => {
        },
        onLeaveBack: () => {
        }
    });

    ScrollTrigger.create({
        trigger: contactRef.current,
        start: 'top -950%',
        end: 'top -1100%',
        duration: 4,
        toggleActions: "play none none none",
        // markers: true,
        onEnter: () => gsap.to(contactRef.current, { backgroundColor: '#111111' }),
    });

    return () => {
        gsap.killTweensOf(homeRef);
        gsap.killTweensOf(manzaRef);
        gsap.killTweensOf(frontendRef);
        gsap.killTweensOf(aboutRef);
        gsap.killTweensOf(backendRef);
        gsap.killTweensOf(aboutDescriptionRef);
        gsap.killTweensOf(aboutProfilePhotoRef);
        gsap.killTweensOf(contactRef);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
}

export default InitGsap